import actions from './actions'
import mutations from './mutations'
// Deprecate use src/app/router/store/index.js
const state = function () {
  return {
    routeBack: 'user-audience-hub',
    routeBackOverride: null
  }
}

// username: state => state.username
const getters = {
}

const module = {
  state,
  getters,
  actions,
  mutations
}

export default module



// WEBPACK FOOTER //
// ./src/app/appLogic/route/store/index.js